export const ADMIN_LANGUAGE_STORAGE_KEY = "bordik_admin_language"

export const ADMIN_LANGUAGES = ["ru", "uz"] as const

export type AdminLanguage = typeof ADMIN_LANGUAGES[number]

export const DEFAULT_ADMIN_LANGUAGE: AdminLanguage = "ru"

export const getAdminIntlLocale = (language: AdminLanguage = getAdminLanguage()) =>
    language === "uz" ? "uz-UZ" : "ru-RU"

export const isAdminLanguage = (value: unknown): value is AdminLanguage =>
    typeof value === "string" && ADMIN_LANGUAGES.includes(value as AdminLanguage)

export const getAdminLanguage = (): AdminLanguage => {
    if (typeof window === "undefined") return DEFAULT_ADMIN_LANGUAGE

    const storedLanguage = window.localStorage.getItem(ADMIN_LANGUAGE_STORAGE_KEY)
    if (isAdminLanguage(storedLanguage)) return storedLanguage

    window.localStorage.setItem(ADMIN_LANGUAGE_STORAGE_KEY, DEFAULT_ADMIN_LANGUAGE)
    return DEFAULT_ADMIN_LANGUAGE
}

export const saveAdminLanguage = (language: AdminLanguage) => {
    if (typeof window !== "undefined") {
        window.localStorage.setItem(ADMIN_LANGUAGE_STORAGE_KEY, language)
    }
}
